import { render, staticRenderFns } from "./CreateFileTemplate.vue?vue&type=template&id=4c01fc7a&lang=pug"
import script from "./CreateFileTemplate.vue?vue&type=script&lang=js"
export * from "./CreateFileTemplate.vue?vue&type=script&lang=js"
import style0 from "./CreateFileTemplate.vue?vue&type=style&index=0&id=4c01fc7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports